import { useEffect } from 'react'
import { loadMetaPixel } from '../utils/metaPixel'

/** Inicializa el Meta Pixel al montar la página. */
export function useMetaPixel(): void {
  useEffect(() => {
    loadMetaPixel()
  }, [])
}
